import React, { useState } from 'react';
import SliderGallery from './GalerySlider';

const galleryInfo = {
  title: "CAD DESK STUDENT GALLERY",
  subtitle: "Meet Our Expert Trainers",
  description:
    "CADDesk Kaniyapuram is a leading CAD/CAM training institute offering industry-relevant courses in Civil, Mechanical, Electrical, and IT domains. Our expert trainers bring real-world experience to deliver practical, job-ready skills to every student.",
  stats: [
    { label: "Students Trained", value: "5 Lakh +" },
    { label: "Courses Offered", value: "25+" },
    { label: "Expert Trainers", value: "10+" },
    { label: "Years Experience", value: "8+" },
  ],
  highlights: [
    {
      icon: "📐",
      title: "Civil & Architecture CAD",
      desc: "AutoCAD, Revit Architecture, Staad Pro, Etabs, Civil 3D, Sketchup, Lumion and more.",
    },
    {
      icon: "⚙️",
      title: "Mechanical CAD",
      desc: "SolidWorks, CATIA, Ansys, Fusion 360, NX CAD, CNC, MEP and more.",
    },
    {
      icon: "⚡",
      title: "Electrical CAD",
      desc: "AutoCAD Electrical, MATLAB, PLC programming for electrical engineers.",
    },
    {
      icon: "💻",
      title: "IT Courses",
      desc: "Full Stack Development, Cyber Security, UI/UX, Graphic Design, Web Development and more.",
    },
    {
      icon: "📊",
      title: "Project Management",
      desc: "MS Project and Primavera for construction and engineering project management.",
    },
    {
      icon: "🏆",
      title: "Placement Support",
      desc: "100% placement assistance with resume building and interview preparation.",
    },
  ],
  contact: {
    address: "First Floor, Shersha Arcade, Vetturoad JN, Kaniyapuram P.O. - 695301",
    phone: "+91 8089657171",
    phone2: "",
    email: "caddeskkaniyapuram@gmail.com",
  },
};

const Gallery = () => {
  const [activeTab, setActiveTab] = useState("about");

  return (
    <div style={styles.page} className='border-top border-1'>
      {/* Top Bar with Social Icons */}
      {/* <div style={styles.topBar}>
        <div style={styles.topBarContainer}>
          <div style={styles.contactInfo}>
            <span style={styles.contactInfoItem}>
              📞 <a href="tel:+918089657171" style={styles.contactInfoLink}>+91 8089657171</a>
            </span>
            <span style={styles.contactInfoItem}>
              ✉️ <a href="mailto:caddeskkaniyapuram@gmail.com" style={styles.contactInfoLink}>caddeskkaniyapuram@gmail.com</a>
            </span>
          </div>
          <div style={styles.socialIcons}>
            <a
              href="https://www.instagram.com/_caddesk_kaniyapuram_/?hl=en"
              style={styles.socialIconLink}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 11.37C16.1234 12.2022 15.9812 13.0522 15.5937 13.799C15.2062 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.908 12.2384 16.0396 11.4077 15.9059C10.5771 15.7723 9.80971 15.3801 9.21479 14.7852C8.61987 14.1903 8.22768 13.4229 8.09402 12.5922C7.96035 11.7615 8.09202 10.9098 8.47028 10.1583C8.84854 9.40683 9.45414 8.79379 10.2009 8.40629C10.9477 8.01879 11.7977 7.8766 12.63 8.00001C13.4789 8.12588 14.2648 8.52146 14.8716 9.1283C15.4785 9.73515 15.8741 10.5211 16 11.37Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M17.5 6.5H17.51" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/people/Caddesk-kaniyapuram/61587576802972/"
              style={styles.socialIconLink}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div> */}

      {/* Page Header */}
      <div style={styles.header}>
        <span style={styles.badge}>✦ OUR GALLERY</span>
        <h1 style={styles.pageTitle}>{galleryInfo.title}</h1>
        <p style={styles.pageSubtitle}>
          Discover our expert trainers and the world-class CAD training we offer
        </p>
      </div>

      {/* Main Content */}
      <div style={styles.mainWrapper}>
        {/* LEFT — Slider */}
        <div style={styles.sliderCol}>
          <SliderGallery />

          {/* Contact Info below slider */}
          {/* <div style={styles.contactBox}>
            <div style={styles.contactItem}>
              <span style={styles.contactIcon}>📍</span>
              <span style={styles.contactText}>{galleryInfo.contact.address}</span>
            </div>
            <div style={styles.contactItem}>
              <span style={styles.contactIcon}>📞</span>
              <div style={styles.contactPhoneGroup}>
                <a href="tel:+918089657171" style={styles.contactLink}>{galleryInfo.contact.phone}</a>
                <span style={styles.contactSeparator}>/</span>
                <a href="tel:+919900502404" style={styles.contactLink}>{galleryInfo.contact.phone2}</a>
              </div>
            </div>
            <div style={styles.contactItem}>
              <span style={styles.contactIcon}>✉️</span>
              <a href={`mailto:${galleryInfo.contact.email}`} style={styles.contactLink}>
                {galleryInfo.contact.email}
              </a>
            </div>
          </div> */}
        </div>

        {/* RIGHT — Info Panel */}
        <div style={styles.infoCol}>
          {/* Tabs */}
          <div style={styles.tabRow}>
            {["about", "courses", "contact"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  ...styles.tabBtn,
                  borderBottom: activeTab === tab
                    ? "2px solid #e67e22"
                    : "2px solid transparent",
                  color: activeTab === tab ? "#e67e22" : "#888",
                  fontWeight: activeTab === tab ? "700" : "400",
                }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {/* About Tab */}
          {activeTab === "about" && (
            <div style={styles.tabContent}>
              <h2 style={styles.infoTitle}>{galleryInfo.subtitle}</h2>
              <p style={styles.infoDesc}>{galleryInfo.description}</p>

              {/* Stats Grid */}
              <div style={styles.statsGrid}>
                {galleryInfo.stats.map((s, i) => (
                  <div key={i} style={styles.statCard}>
                    <span style={styles.statValue}>{s.value}</span>
                    <span style={styles.statLabel}>{s.label}</span>
                  </div>
                ))}
              </div>

              {/* Why CADDesk */}
              <div style={styles.whyBox}>
                <div style={styles.whyTitle}>Why Choose CADDesk?</div>
                {[
                  "Industry-certified trainers with real project experience",
                  "Hands-on practical training on latest software versions",
                  "Flexible batch timings — weekday & weekend",
                  "Affordable fees with EMI options available",
                  "Certificate recognized by top companies",
                ].map((point, i) => (
                  <div key={i} style={styles.whyPoint}>
                    <span style={styles.whyDot}>✔</span>
                    <span style={styles.whyText}>{point}</span>
                  </div>
                ))}
              </div>

            </div>
          )}

          {/* Courses Tab */}
          {activeTab === "courses" && (
            <div style={styles.tabContent}>
              <h2 style={styles.infoTitle}>Our Courses</h2>
              <p style={styles.infoDesc}>
                We offer a wide range of CAD, CAM and IT courses designed for
                engineering students and working professionals.
              </p>
              <div style={styles.highlightList}>
                {galleryInfo.highlights.map((h, i) => (
                  <div key={i} style={styles.highlightCard}>
                    <div style={styles.highlightIcon}>{h.icon}</div>
                    <div>
                      <div style={styles.highlightTitle}>{h.title}</div>
                      <div style={styles.highlightDesc}>{h.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Contact Tab */}
          {activeTab === "contact" && (
            <div style={styles.tabContent}>
              <h2 style={styles.infoTitle}>Get In Touch</h2>
              <p style={styles.infoDesc}>
                Visit us at our Kaniyapuram centre or reach out online.
                Our team is happy to guide you in choosing the right course.
              </p>

              <div style={styles.contactCard}>
                <div style={styles.contactCardItem}>
                  <span style={styles.contactCardIcon}>📍</span>
                  <div>
                    <div style={styles.contactCardLabel}>Address</div>
                    <div style={styles.contactCardValue}>
                      {galleryInfo.contact.address}
                    </div>
                  </div>
                </div>
                <div style={styles.contactCardItem}>
                  <span style={styles.contactCardIcon}>📞</span>
                  <div>
                    <div style={styles.contactCardLabel}>Phone</div>
                    <div style={styles.contactCardValue}>
                      <a href="tel:+918089657171" style={styles.contactCardLink}>{galleryInfo.contact.phone}</a>
                      <span style={styles.contactSeparator}>  </span>
                      <a href="tel:+919900502404" style={styles.contactCardLink}>{galleryInfo.contact.phone2}</a>
                    </div>
                  </div>
                </div>
                <div style={styles.contactCardItem}>
                  <span style={styles.contactCardIcon}>✉️</span>
                  <div>
                    <div style={styles.contactCardLabel}>Email</div>
                    <a
                      href={`mailto:${galleryInfo.contact.email}`}
                      style={styles.contactCardLink}
                    >
                      {galleryInfo.contact.email}
                    </a>
                  </div>
                </div>
                <div style={styles.contactCardItem}>
                  <span style={styles.contactCardIcon}>🕐</span>
                  <div>
                    <div style={styles.contactCardLabel}>Working Hours</div>
                    <div style={styles.contactCardValue}>
                      Mon – Sat: 9:30 AM – 5:00 PM
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Icons with Images */}
              <div style={styles.socialRow}>
                <span style={styles.socialLabel}>Follow Us:</span>
                <div style={styles.socialIconGroup}>
                  <a
                    href="https://www.instagram.com/_caddesk_kaniyapuram_/?hl=en"
                    target="_blank"
                    rel="noreferrer"
                    style={styles.socialImageLink}
                    title="Instagram"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg"
                      alt="Instagram"
                      width="28"
                      height="28"
                      style={styles.socialImg}
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/people/Caddesk-kaniyapuram/61587576802972/"
                    target="_blank"
                    rel="noreferrer"
                    style={styles.socialImageLink}
                    title="Facebook"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
                      alt="Facebook"
                      width="28"
                      height="28"
                      style={styles.socialImg}
                    />
                  </a>
                </div>
              </div>

            
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "#f8f6f2",
  
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  
  },
  topBar: {
    background: "#1a1a2e",
    padding: "10px 0",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  topBarContainer: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  contactInfo: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
  },
  contactInfoItem: {
    fontSize: "13px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  contactInfoLink: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "13px",
    transition: "color 0.2s",
    ':hover': {
      color: "#e67e22",
    }
  },
  socialIcons: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },
  socialIconLink: {
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s",
    ':hover': {
      color: "#e67e22",
      transform: "translateY(-2px)",
    }
  },
  header: {
    textAlign: "center",
    marginBottom: "10px",
    paddingTop: "10px",
  },
  badge: {
    display: "inline-block",
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "0.15em",
    color: "#e67e22",
    background: "rgba(230,126,34,0.1)",
    padding: "5px 14px",
    borderRadius: "30px",
    marginBottom: "12px",
  },
  pageTitle: {
    fontSize: "clamp(1.8rem, 4vw, 3rem)",
    fontWeight: "800",
    color: "#1a1a2e",
    margin: "0 0 10px",
    letterSpacing: "-0.02em",
  },
  pageSubtitle: {
    fontSize: "15px",
    color: "#888",
    maxWidth: "520px",
    margin: "0 auto",
    lineHeight: "1.6",
  },
  mainWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    maxWidth: "1400px",
    margin: "0 auto",
    alignItems: "flex-start",
    flexWrap: "wrap",
    padding: "0 20px 60px",
  },
  sliderCol: {
    flex: "1 1 55%",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  infoCol: {
    flex: "1 1 25%",
    minWidth: "250px",
    background: "#fff",
    borderRadius: "5px",
    padding: "20px 20px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  tabRow: {
    display: "flex",
    borderBottom: "1px solid #eee",
    gap: "8px",
  },
  tabBtn: {
    flex: 1,
    background: "none",
    border: "none",
    padding: "12px 0",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    letterSpacing: "0.05em",
    textTransform: "capitalize",
    transition: "all 0.2s",
    backgroundColor: "transparent",
  },
  tabContent: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  infoTitle: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#1a1a2e",
    margin: 0,
  },
  infoDesc: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.7",
    margin: 0,
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  },
  statCard: {
    background: "#f8f6f2",
    borderRadius: "14px",
    padding: "10px 10px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  statValue: {
    fontSize: "24px",
    fontWeight: "800",
    color: "#e67e22",
  },
  statLabel: {
    fontSize: "11px",
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  whyBox: {
    background: "#f8f6f2",
    borderRadius: "14px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  whyTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#1a1a2e",
    marginBottom: "2px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  whyPoint: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
  },
  whyDot: {
    color: "#e67e22",
    fontWeight: "700",
    fontSize: "12px",
    marginTop: "1px",
    minWidth: "18px",
  },
  whyText: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5",
  },
  ctaBtn: {
    background: "#e67e22",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    padding: "14px 24px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    letterSpacing: "0.05em",
    alignSelf: "flex-start",
    transition: "all 0.3s",
  },
  highlightList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    maxHeight: "400px",
    overflowY: "auto",
    paddingRight: "8px",
  },
  highlightCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    background: "#f8f6f2",
    borderRadius: "14px",
    padding: "10px 10px",
    transition: "all 0.2s",
  },
  highlightIcon: {
    fontSize: "24px",
    minWidth: "32px",
    textAlign: "center",
  },
  highlightTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "#1a1a2e",
    marginBottom: "1px",
  },
  highlightDesc: {
    fontSize: "12px",
    color: "#888",
    lineHeight: "1.5",
  },
  contactBox: {
    background: "#fff",
    borderRadius: "20px",
    padding: "20px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  contactIcon: {
    fontSize: "18px",
    minWidth: "24px",
  },
  contactText: {
    fontSize: "13px",
    color: "#555",
    lineHeight: "1.5",
  },
  contactPhoneGroup: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexWrap: "wrap",
  },
  contactSeparator: {
    color: "#999",
    fontSize: "13px",
  },
  contactLink: {
    fontSize: "13px",
    color: "#e67e22",
    textDecoration: "none",
    fontWeight: "600",
    transition: "color 0.2s",
  },
  contactCard: {
    background: "#f8f6f2",
    borderRadius: "16px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  contactCardItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px",
    paddingBottom: "12px",
    borderBottom: "1px solid #e0e0e0",
  },
  contactCardIcon: {
    fontSize: "20px",
    minWidth: "28px",
  },
  contactCardLabel: {
    fontSize: "11px",
    color: "#999",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginBottom: "4px",
  },
  contactCardValue: {
    fontSize: "13px",
    color: "#444",
    lineHeight: "1.5",
  },
  contactCardLink: {
    fontSize: "13px",
    color: "#e67e22",
    textDecoration: "none",
    fontWeight: "600",
    transition: "color 0.2s",
  },
  socialRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  socialLabel: {
    fontSize: "12px",
    color: "#aaa",
    fontWeight: "500",
  },
  socialIconGroup: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  socialImageLink: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s",
    textDecoration: "none",
  },
  socialImg: {
    transition: "transform 0.2s",
    objectFit: "contain",
  },
};

export default Gallery;